import { render, staticRenderFns } from "./TreatmentList.vue?vue&type=template&id=4652887d&scoped=true&lang=pug"
import script from "./TreatmentList.vue?vue&type=script&lang=js"
export * from "./TreatmentList.vue?vue&type=script&lang=js"
import style0 from "./TreatmentList.vue?vue&type=style&index=0&id=4652887d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4652887d",
  null
  
)

export default component.exports